import { render, staticRenderFns } from "./index--detail.vue?vue&type=template&id=299f16de&scoped=true&"
import script from "./index--detail.vue?vue&type=script&lang=js&"
export * from "./index--detail.vue?vue&type=script&lang=js&"
import style0 from "./index--detail.vue?vue&type=style&index=0&id=299f16de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f16de",
  null
  
)

export default component.exports